<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CQSmlN/tc-custom/9781497684782.jpg?1734044445728" alt="This image is the cover for the book Essays in Skepticism"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Essays in Skepticism
      </h1>
      <p class="bookDescription body article font2">
        <b>From one of the greatest philosophers of the twentieth century: A collection of accessible and enlightening essays on topics from envy to intellectual rubbish.</b><br/><br/> Russell, the sage non-conformist, is always meaningful, no matter what the topic or the issue. In this small book are some of his old but nonetheless remarkable observations, and some of the thoughts he expressed on his 90th birthday. Here are titles, taken at random from the Table of Contents: Psychoanalysis Takes a Look; Envy and Belief; On Male Superiority; What Social Science Can Do; Intellectual Rubbish; Don’t Be Too Certain; On Being Old.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bertrand Russell
      </h2>
      
      <p class="authorDescription body article">Bertrand Arthur William Russell, 3rd Earl Russell was a British philosopher, logician, mathematician, historian, social reformer, and pacifist. Although he spent the majority of his life in England, he was born in Wales, where he also died. Russell led the British &ldquo;revolt against Idealism&rdquo; in the early twentieth century and is one of the founders of analytic philosophy along with his prot&eacute;g&eacute; Wittgenstein and his elder Frege. He co-authored, with A. N. Whitehead, <I>Principia Mathematica</I>, an attempt to ground mathematics on logic. His philosophical essay &ldquo;On Denoting&rdquo; has been considered a &ldquo;paradigm of philosophy.&rdquo; Both works have had a considerable influence on logic, mathematics, set theory, linguistics and analytic philosophy. He was a prominent anti-war activist, championing free trade between nations and anti-imperialism. Russell was imprisoned for his pacifist activism during World War I, campaigned against Adolf Hitler, for nuclear disarmament. He criticized Soviet totalitarianism and the United States of America&rsquo;s involvement in the Vietnam War. In 1950, Russell was awarded the Nobel Prize in Literature, &ldquo;in recognition of his varied and significant writings in which he champions humanitarian ideals and freedom of thought.&rdquo;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2fd05b04